module.exports = __webpack_public_path__ + "static/media/gryphon_musee_northvanarts_2.e68cfbbb.jpg";